import React, { useEffect, useState } from "react";
import scheduleDataStore from "Stores/ScheduleData";
import { weekDays } from "Static/constant";
import Utils from "Utils/utils";
import AutoCompleteDropdown from "Components/common/AutoCompleteDropdown";
import CommonPopup from "Components/common/CommonPopup";
import CreateOrEditSchedules from "Pages/Dashboard/settings/Schedules/CreateOrEditSchedules";
import { initialSchedulePopupState } from "./InitialScheduleInfoPopup";
import { observer } from "mobx-react";

const CreateNewSchedule = props => {
  const { onCreateClick = () => {} } = props || {};

  return (
    <div className="createNewScheduleBtn" onClick={onCreateClick}>
      <i className="material-icons">add</i>
      <span className="btnText">Create new schedule</span>
    </div>
  );
};

const InitialSchedule = observer((props = {}) => {
  const { scheduleWindowId = "" } = props || {};

  const [scheduleId, setScheduleId] = useState(scheduleWindowId);
  const [scheduleWindow, setScheduleWindow] = useState({});
  const [showCreateSchedulePopup, setShowCreateSchedulePopup] = useState(
    false
  );
  let tempWeekDays = [];

  const handleSetAction = (id = "", value = "") => {
    initialSchedulePopupState.setScheduleState({
      ...initialSchedulePopupState?.scheduleState,
      [id]: value
    });
  };

  const getDefaultScheduleData = () => {
    const tempData = scheduleDataStore?.scheduleData?.data;
    const filteredData = tempData?.filter(item => item.id === scheduleId)?.[0];
    setScheduleWindow({ ...filteredData });
    handleSetAction("scheduleWindowId", filteredData?.id);
    scheduleDataStore.setDefaultData({ ...filteredData });
  };

  const getUpdatedTimeRange = () => {
    const dailyTimeRange = scheduleWindow?.dailyTimeRange;

    for (var day in weekDays) {
      const initialTimeRange = dailyTimeRange?.[day]?.map(item => {
        const { fromTime = "", toTime = "" } = item;
        return `${Utils.getCustomTime(fromTime)} - ${Utils.getCustomTime(
          toTime
        )}`;
      });

      tempWeekDays.push({
        long: weekDays[day]?.long,
        timeRange: initialTimeRange
      });
    }
    return tempWeekDays;
  };

  const getScheduleWindow = () => {
    const tempWeekDays = getUpdatedTimeRange();

    return tempWeekDays?.map((item, index) => {
      const { long = "", timeRange = [] } = item || {};
      return (
        <div
          className="daysWithTimeWrapper"
          key={`daysWithTimeWrapper${index}`}
        >
          <span className="weekDays">{long}</span>
          <span className={`TimeRange ${timeRange?.[0] ? "" : "emptyResult"}`}>
            {timeRange?.[0] || "--"}
          </span>
        </div>
      );
    });
  };

  const scheduleWindowCbk = item => {
    setScheduleWindow({ ...item });
    handleSetAction("scheduleWindowId", item?.id);
  };

  const handleNewScheduleCreated = newSchedule => {
    setScheduleWindow({ ...newSchedule });
    handleSetAction("scheduleWindowId", newSchedule?.id);
    scheduleDataStore.setDefaultData({ ...newSchedule });
  };

  useEffect(() => {
    if (scheduleWindowId && scheduleWindowId !== scheduleId) {
      setScheduleId(scheduleWindowId);
    }
  }, [scheduleWindowId, scheduleId]);

  useEffect(() => {
    getDefaultScheduleData(scheduleDataStore?.scheduleData);
  }, [scheduleId, scheduleDataStore.scheduleData]);

  return (
    <div className="schedulesWrapper">
      {Object.keys(scheduleWindow).length > 0 ? (
        <>
          <div className="scheduleBody">
            <div className="headerTitle">
              Your emails & tasks will be scheduled during these time frames in
              a day
            </div>
            <AutoCompleteDropdown
              optionList={scheduleDataStore?.scheduleData?.data}
              defaultValue={scheduleWindow?.name}
              cbk={scheduleWindowCbk}
            >
              <CreateNewSchedule
                onCreateClick={() => setShowCreateSchedulePopup(true)}
              />
            </AutoCompleteDropdown>
          </div>
          <div className="sendingWindow">
            <div className="timeZone">
              Timezone: {scheduleWindow?.timezoneName || ""}
            </div>
            <div className="flexCenter">
              <div className="scheduleWindowPanel">{getScheduleWindow()}</div>
            </div>
          </div>
        </>
      ) : (
        <section className="sequenceThrottlingSettings">
          <div className="autoCompleteDropdownLoading">
            <div className="inputBoxLoader linear-background" />
          </div>
          <div className="sendingWindowLoading">
            <div className="labelLoader linear-background" />
            {Array.from({ length: 7 }, (value, index) => (
              <div
                className="daysWithTimeWrapper"
                key={`daysWithTimeWrapper${index}`}
              >
                <div className="weekDays linear-background" />
                <div className="TimeRange linear-background" />
              </div>
            ))}
          </div>
        </section>
      )}
      {showCreateSchedulePopup && (
        <CommonPopup
          headerTitle="Create new schedule"
          className="createScheduleFromSequencePopup"
          closeIconCbk={() => setShowCreateSchedulePopup(false)}
        >
          <CreateOrEditSchedules
            hideCbk={() => setShowCreateSchedulePopup(false)}
            onSaveSuccess={handleNewScheduleCreated}
          />
        </CommonPopup>
      )}
    </div>
  );
});

export { InitialSchedule };
export default InitialSchedule;
